import * as VueRouter from "vue-router";

const router = VueRouter.createRouter({
    history: VueRouter.createWebHistory(),
    routes: [
        {
            path: "/",
            name: "home",
            component: () => import("../views/Home.vue"),
        },
        {
            path: "/datatable",
            name: "datatable",
            component: () => import("../views/Datatable.vue"),
        },
        {
            path: "/formbuilder",
            name: "formbuilder",
            component: () => import("../views/Formbuilder.vue"),
        },
        {
            path: "/template",
            name: "template",
            component: () => import("../views/Template.vue"),
        },
        { path: '/:pathMatch(.*)*', redirect: '/' }
    ],
});

export default router;
